/**
 * Resolves the single record control's appearance and behaviour.
 *
 * @param {IRecordControlInput} input - Capture phase and the user's pending
 * intent.
 * @returns {IRecordControlState} What to draw and what a press should do.
 */
export function getRecordControlState({ capturePhase, captureRequested, saving = false, stopRequested }) {
    if (saving || (capturePhase === 'recording' && stopRequested)) {
        return { action: 'none', busy: true, enabled: false, label: 'Finishing recording', shape: 'square' };
    }
    if (capturePhase === 'recording') {
        return { action: 'stop', busy: false, enabled: true, label: 'Stop recording', shape: 'square' };
    }
    // A recorder is assigned but is not capturing yet: it spends about ten
    // seconds launching a browser and joining before anything is written.
    // Saying "recording" here would invite someone to start signing into a
    // take that has not begun.
    if (capturePhase === 'arming' || captureRequested) {
        return { action: 'none', busy: true, enabled: false, label: 'Starting recording', shape: 'circle' };
    }
    if (capturePhase === 'starting') {
        return { action: 'start', busy: false, enabled: true, label: 'Start recording', shape: 'circle' };
    }
    return capturePhase === 'camera-unavailable'
        ? { action: 'none', busy: false, enabled: false, label: 'Camera unavailable', shape: 'circle' }
        : { action: 'none', busy: true, enabled: false, label: 'Waiting for camera', shape: 'circle' };
}
/**
 * Whether the way out of the recorder is shown next to the record control.
 *
 * Before a take starts, it is "Cancel": nothing has been recorded, so there is
 * nothing to discard. From the press until the take is saved it is hidden,
 * and the record control is the only control; Discard is on the review that
 * follows (owner report 2026-10-08: Discard was shown before the take and all
 * through it).
 *
 * @param {IRecordControlInput} input - The same input as the record control.
 * @returns {boolean} True when Cancel is shown.
 */
export function canCancelBeforeTake({ capturePhase, captureRequested, saving = false, stopRequested }) {
    return !saving && !stopRequested && !captureRequested
        && capturePhase !== 'arming' && capturePhase !== 'recording';
}
